var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_9_",
    transform: "translate(-200.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-1_3_",
    transform: "translate(200.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook_1_",
    className: "st0",
    d: "M26.5,47.1H5.3c-1.3,0-2.4-1.1-2.4-2.4V5.3 C2.9,4,4,2.9,5.3,2.9h39.3c1.3,0,2.4,1.1,2.4,2.4v39.3c0,1.3-1.1,2.4-2.4,2.4H33.4V30h5.7l0.9-6.7h-6.6v-4.3 c0-1.9,0.5-3.2,3.3-3.2l3.5,0v-6c-0.6-0.1-2.7-0.3-5.1-0.3c-5.1,0-8.6,3.1-8.6,8.8v4.9h-5.8V30h5.8V47.1L26.5,47.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.947fb2db18f886cc4a490fa6f95cd715.svg";
export { ForwardRef as ReactComponent };